_collow.components.Quiz = class Quiz extends _collow.components.Base {
  root;
  elements;
  params;
  currentQuestion = 0;
  ammountOfPoints = [];
  registrationId;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    // Attach event listeners more efficiently
    this.listen(elements.next, "click", this.nextQuestion);
    this.listen(elements.start, "click", this.startQuiz);
    this.listen(elements.prev, "click", this.prevQuestion);
    this.listen(elements.finish, "click", this.finishQuiz);

    // Use arrow function to maintain this context
    this.listen(document.body, "_collow.quiz-points", this.handleQuizPoints);
    this.listen(document.body, "_collow.hide-all-quiz", this.hideAllQuiz);

    if (elements?.finishFinalQuiz) {
      this.listen(elements.finishFinalQuiz, "click", this.handleFinishFinalQuiz);
    }
    
    this.listen(document.body, "_collow.show-finish-button", this.handleCodeQuizfinish);
  }

  startQuiz = () => {
    this.dispatch(this.root, "_collow.course-toggle-nav");
    this.nextQuestion();
  };

  nextQuestion = () => {
    this.elements.next.setAttribute("hidden", "");
    this.currentQuestion += 1;
    this.renderQuestions(1);
  };

  prevQuestion = () => {
    this.currentQuestion -= 1;
    this.renderQuestions(-1);
  };

  handleQuizPoints = ({ detail }) => {
    if (this.params.length > detail.index) {
      this.elements.next.removeAttribute("hidden");
    }
    this.ammountOfPoints[detail.index] = detail.points;
  };

  hideAllQuiz = () => {
    const elements = [this.elements.results, this.elements.questions];
    for (const el of elements) {
      if (el) el.setAttribute("hidden", "");
    }
  };

  handleFinishFinalQuiz = () => {
    this.dispatch(this.root, "_collow.finish-final-quiz");
  };

  renderQuestions = (value) => {
    const questionsChildren = this.elements.questions.children;
    const prevQuestion = questionsChildren[this.currentQuestion - value];
    const currentQuestion = questionsChildren[this.currentQuestion];
    
    if (prevQuestion) {
      prevQuestion.setAttribute("hidden", "");
    }
    
    if (currentQuestion) {
      currentQuestion.removeAttribute("hidden");
    }

    // Update navigation buttons visibility
    if (this.currentQuestion === 2) {
      this.elements.prev.removeAttribute("hidden");
    } else if (this.currentQuestion < 2) {
      this.elements.prev.setAttribute("hidden", "");
    }

    const isCodeQuestion = [...this.root.querySelectorAll(".quiz-code[data-quiz-code\\:language]")].some(el => el.offsetParent !== null);
    const isLastQuestion = this.params.length + 1 === this.currentQuestion;
    if (isLastQuestion && !isCodeQuestion) {
      this.elements.next.setAttribute("hidden", "");
      this.elements.finish.removeAttribute("hidden");
    } else {
      this.elements.finish.setAttribute("hidden", "");
    }

    // Show next button if previous question has points
    if (this.ammountOfPoints[this.currentQuestion - 1] >= 0) {
      this.elements.next.removeAttribute("hidden");
    }
  };

  handleCodeQuizfinish = () => {
    const isLastQuestion = this.params.length + 1 === this.currentQuestion;
    if (!isLastQuestion) return;
    this.elements.finish.removeAttribute("hidden");
  }

  finishQuiz = () => {
    this.dispatch(this.root, "_collow.course-toggle-nav");
    
    // Calculate total points more efficiently
    let collectedPoints = 0;
    for (const points of this.ammountOfPoints) {
      if (!isNaN(points)) {
        collectedPoints += points;
      }
    }
    collectedPoints = Math.round(collectedPoints);
    
    // Determine if passed
    const passed = collectedPoints >= this.params.threshold ? 1 : 2;
    if (collectedPoints >= this.params.threshold) {
      const finishElement = this.elements.finishQuiz || this.elements.finishFinalQuiz;
      if (finishElement) {
        finishElement.removeAttribute("hidden");
      }
    }

    // Prepare quiz info
    const quizInfo = {
      points: collectedPoints,
      max_points: this.params.totalPoints,
      min_points: this.params.threshold,
      status: passed,
    };

    // Dispatch finished event
    this.dispatch(this.root, "_collow.quiz-finished", quizInfo);
    
    // Update UI elements
    if (this.elements.results && this.elements.results.dataset) {
      this.elements.results.dataset.quizStatus = "finished";
    }
    
    if (this.elements.resultsPoints) {
      this.elements.resultsPoints.innerHTML = collectedPoints;
    }

    // Show all questions
    if (this.elements.questions && this.elements.questions.childNodes) {
      const childNodes = this.elements.questions.childNodes;
      for (let i = 0; i < childNodes.length; i++) {
        const el = childNodes[i];
        if (i > 0 && el && typeof el.removeAttribute === 'function') {
          el.removeAttribute("hidden");
        }
      }
    }
    
    // Hide navigation buttons
    const buttons = [this.elements.prev, this.elements.next, this.elements.finish];
    for (const el of buttons) {
      if (el && typeof el.setAttribute === 'function') {
        el.setAttribute("hidden", "");
      }
    }
  };
};
